module.exports = __webpack_public_path__ + "static/media/myob_logo.015e3308.png";